document.addEventListener("DOMContentLoaded", function () {
  let summaryItems = document.querySelectorAll(".menu-summary-item");
  let submenuContents = document.querySelectorAll(".submenu-content");

  summaryItems.forEach((item) => {
    item.addEventListener("mouseenter", function () {
      let i = this.getAttribute("data-index");

      // Remove active class from all summary items
      document
        .querySelectorAll(".menu-summary-title")
        .forEach((el) => el.classList.remove("active"));
      this.querySelector(".menu-summary-title").classList.add("active");

      // Hide all submenus
      submenuContents.forEach((submenu) => {
        submenu.classList.remove("show");
      });

      // Show the corresponding submenu
      let targetSubmenus = document.querySelectorAll(
        `.submenu-content[data-index='${i}']`
      );
      // console.log('targetSubmenus', targetSubmenus);
      targetSubmenus.forEach((targetSubmenu) => {
        if (targetSubmenu) {
          targetSubmenu.classList.add("show");
        } else {
          console.error(`No submenu found for index ${i}`);
        }
      });
    });
  });

  document.querySelectorAll(".grandchild-toggle").forEach((toggle) => {
    toggle.addEventListener("click", function (event) {
      event.stopPropagation(); // Prevent event bubbling

      let targetId = this.getAttribute("data-target");
      let grandchildMenu = document.getElementById(targetId);

      if (grandchildMenu) {
        // Close all other grandchild menus before opening the clicked one
        document.querySelectorAll(".grandchild-menu").forEach((menu) => {
          if (menu !== grandchildMenu) {
            menu.classList.remove("show");
            document.querySelector(`[data-target="${menu.id}"]`).innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M4.61127 8.73041C4.9367 8.40497 5.46434 8.40497 5.78978 8.73041L10.2005 13.1411L14.6113 8.73041C14.9367 8.40497 15.4643 8.40497 15.7898 8.73041C16.1152 9.05584 16.1152 9.58348 15.7898 9.90892L10.7898 14.9089C10.4643 15.2344 9.9367 15.2344 9.61127 14.9089L4.61127 9.90892C4.28583 9.58348 4.28583 9.05584 4.61127 8.73041Z" fill="currentColor"/>
                </svg>`;
          }
        });

        // Toggle the clicked grandchild menu
        grandchildMenu.classList.toggle("show");

        this.innerHTML = grandchildMenu.classList.contains("show")
          ? `
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10.1113 6.56439C10.4367 6.23895 10.9643 6.23895 11.2898 6.56439L16.2898 11.5644C16.6152 11.8898 16.6152 12.4175 16.2898 12.7429C15.9643 13.0683 15.4367 13.0683 15.1113 12.7429L10.7005 8.33216L6.28978 12.7429C5.96434 13.0683 5.4367 13.0683 5.11127 12.7429C4.78583 12.4175 4.78583 11.8898 5.11127 11.5644L10.1113 6.56439Z" fill="currentColor"/>
            </svg>`
          : `
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M4.61127 8.73041C4.9367 8.40497 5.46434 8.40497 5.78978 8.73041L10.2005 13.1411L14.6113 8.73041C14.9367 8.40497 15.4643 8.40497 15.7898 8.73041C16.1152 9.05584 16.1152 9.58348 15.7898 9.90892L10.7898 14.9089C10.4643 15.2344 9.9367 15.2344 9.61127 14.9089L4.61127 9.90892C4.28583 9.58348 4.28583 9.05584 4.61127 8.73041Z" fill="currentColor"/>
            </svg>`;
      }
    });
  });

  // Close grandchild menu when clicking outside
  document.addEventListener("click", function (event) {
    if (!event.target.closest(".submenu-item")) {
      document.querySelectorAll(".grandchild-menu").forEach((menu) => {
        menu.classList.remove("show");
        document.querySelector(`[data-target="${menu.id}"]`).innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M4.61127 8.73041C4.9367 8.40497 5.46434 8.40497 5.78978 8.73041L10.2005 13.1411L14.6113 8.73041C14.9367 8.40497 15.4643 8.40497 15.7898 8.73041C16.1152 9.05584 16.1152 9.58348 15.7898 9.90892L10.7898 14.9089C10.4643 15.2344 9.9367 15.2344 9.61127 14.9089L4.61127 9.90892C4.28583 9.58348 4.28583 9.05584 4.61127 8.73041Z" fill="currentColor"/>
            </svg>`;
      });
    }
  });
});
// *******************************************************

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".submenu-item").forEach(function (item) {
    // Hover Effect
    // item.addEventListener("mouseenter", function () {
    //     let grandchildMenu = this.querySelector(".grandchild-menu");
    //     if (grandchildMenu) {
    //         grandchildMenu.classList.add("active");
    //     }
    // });

    // item.addEventListener("mouseleave", function () {
    //     let grandchildMenu = this.querySelector(".grandchild-menu");
    //     if (grandchildMenu) {
    //         grandchildMenu.classList.remove("active");
    //     }
    // });

    // Click Effect
    item.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default action if it's a link
      let grandchildMenu = this.querySelector(".grandchild-menu");
      if (grandchildMenu) {
        grandchildMenu.classList.toggle("active");
      }
    });
  });
});

// *******************************************************
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelector(".ll-menu--close")
    .addEventListener("click", function () {
      document.body.classList.remove("overflow-hidden-tablet");
    });
});
// *******************************************************
document.addEventListener("DOMContentLoaded", function () {
  const style = document.createElement("style");
  style.innerHTML = `
        .hw-hot-deals-section .swiper-slide:before {
            content: '';
            background: var(--al--brand-300);
            opacity: .2;
            width: 100%;
            height: 45%;
            transform: scale(1.8);
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            border-radius: 0 0 76rem 76rem;
            z-index: 0;
        }
    `;
  document.head.appendChild(style);
});
// *******************************************************
document.addEventListener("DOMContentLoaded", function () {
  if (typeof window.hwReInitProductCards === "function") {
    window.hwReInitProductCards();
  }

  // === Grid/List Toggle Logic ===
  if (document.body.classList.contains("template-collection")) {
    const productGrid = document.getElementById("product-grid");
    const gridViewBtn = document.getElementById("gridViewBtn");
    const listViewBtn = document.getElementById("listViewBtn");

    const variantElements = document.querySelectorAll(
      ".hw--custom-product-variant.hw--custom-product-variant-listview, .hw--custom-product-variant .card__heading"
    );

    productGrid.classList.add(
      "grid--2-col-tablet-down",
      "grid--4-col-desktop",
      "hw--gridview"
    );

    function setActiveView(view) {
      if (view === "grid") {
        productGrid.classList.remove(
          "grid--1-col-tablet-down",
          "grid--2-col-desktop",
          "hw--listview"
        );
        productGrid.classList.add(
          "grid--2-col-tablet-down",
          "grid--4-col-desktop",
          "hw--gridview"
        );

        gridViewBtn.classList.add("active");
        listViewBtn.classList.remove("active");

        variantElements.forEach((el) => {
          el.style.display = "none";
        });
      } else {
        productGrid.classList.remove(
          "grid--2-col-tablet-down",
          "grid--4-col-desktop",
          "hw--gridview"
        );
        productGrid.classList.add(
          "grid--1-col-tablet-down",
          "grid--2-col-desktop",
          "hw--listview"
        );

        listViewBtn.classList.add("active");
        gridViewBtn.classList.remove("active");

        variantElements.forEach((el) => {
          el.style.display = "block";
        });
      }

      // ✅ Re-run price/variant logic after view switch
      if (typeof window.hwReInitProductCards === "function") {
        window.hwReInitProductCards();
      }
    }

    gridViewBtn.addEventListener("click", function () {
      setActiveView("grid");
    });

    listViewBtn.addEventListener("click", function () {
      setActiveView("list");
    });

    // Hide variant UI on initial grid load
    variantElements.forEach((el) => {
      el.style.display = "none";
    });
  }
});

// *******************************************************
document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains("template-collection")) {
    // Toggle the main dropdown
    document
      .querySelector(".Hw-al__dropdown-title")
      .addEventListener("click", function (event) {
        event.stopPropagation(); // Prevent conflicts
        var dropdownContainer = document.querySelector(
          ".Hw-al__dropdown-container"
        );
        dropdownContainer.classList.toggle("active");

        // Toggle chevron icon
        var chevronIcon = this.querySelector(".Hw-al__chevron-icon");
        chevronIcon.classList.toggle("rotate");
      });

    // Toggle collection dropdowns
    document
      .querySelectorAll(".Hw-al__collection-header.Hw-al__toggle-dropdown")
      .forEach(function (header) {
        header.addEventListener("click", function (event) {
          event.stopPropagation(); // Prevent conflicts
          var parent = this.closest(".Hw-al__collection-item");
          parent.classList.toggle("active");

          // Toggle collection chevron icon
          var chevronIcon = this.querySelector(
            ".Hw-al__chevron-icon-collection"
          );
          if (chevronIcon) {
            chevronIcon.classList.toggle("rotate");
          }
        });
      });
  }
});
// *******************************************************
document.addEventListener("DOMContentLoaded", function () {
  const filterHamburger = document.querySelector(".hw--filter-hamburger");
  const filterMain = document.querySelector(".hw--filter-main");
  const body = document.body;
  const closeButton = document.querySelector(".hw--filter-hamburger-close");

  // Create the overlay element
  const overlay = document.createElement("div");
  overlay.classList.add("hw--overlay");
  document.body.appendChild(overlay);

  // Function to open filter and overlay
  function openFilter() {
    filterMain.classList.add("hw--visibal");
    body.classList.add("overflow-hidden-tablet");
    overlay.classList.add("hw--overlay-active"); // Show overlay
  }

  // Function to close filter and overlay
  function closeFilter() {
    filterMain.classList.remove("hw--visibal");
    body.classList.remove("overflow-hidden-tablet");
    overlay.classList.remove("hw--overlay-active"); // Hide overlay
  }

  // Event listeners
  if (filterHamburger) {
    filterHamburger.addEventListener("click", openFilter);
  }

  if (closeButton) {
    closeButton.addEventListener("click", closeFilter);
  }

  overlay.addEventListener("click", closeFilter); // Close when clicking on overlay
});

// *******************************************************
document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains("template-collection")) {
    document.getElementById("SortBy").addEventListener("change", function () {
      setTimeout(function () {
        location.reload();
      }, 800);
    });
  }
});
// *******************************************************
document.addEventListener("DOMContentLoaded", function () {
  // Portable Text JSON to HTML converter
  function renderPortableText(portableText) {
    try {
      const data =
        typeof portableText === "string"
          ? JSON.parse(portableText)
          : portableText;
      if (!data || !data.children) return "";

      let html = "";

      data.children.forEach((block) => {
        if (block.type === "paragraph") {
          html += "<p>";
          block.children?.forEach((child) => {
            if (child.bold) {
              html += `<strong>${child.value}</strong>`;
            } else {
              html += `${child.value}`;
            }
          });
          html += "</p>";
        }

        if (block.type === "list" && block.listType === "unordered") {
          html += "<ul>";
          block.children?.forEach((item) => {
            html += "<li>";
            item.children?.forEach((child) => {
              html += `${child.value}`;
            });
            html += "</li>";
          });
          html += "</ul>";
        }

        // Extend more block types here if needed
      });

      return html;
    } catch (e) {
      console.warn("Error parsing Portable Text:", e);
      return "";
    }
  }

  // Update all product info based on selected variant
  function updateProductInfo(productInput) {
    if (!productInput) return;

    const sku = productInput.getAttribute("data-sku") || "";
    const weight = productInput.getAttribute("data-weight") || "";
    const dim = productInput.getAttribute("data-dim") || "";
    const variantDescription =
      productInput.getAttribute("data-description") || "";
    const variantImageUrl =
      productInput.getAttribute("data-description-image") || "";
    const additionalInformationImageUrl =
      productInput.getAttribute("data-additional_information_image") || "";
    const country =
      productInput.getAttribute("data-country") || "Not specified";

    const skuElement = document.querySelector(".Hw__information_sku");
    const weightElement = document.querySelector(".Hw__information_weight");
    const dimElement = document.querySelector(".Hw__information_dim");
    const countryElement = document.querySelector(".Hw__information_country");
    const descriptionElement = document.querySelector(
      ".Hw__product_description_text"
    );
    const imageElement = document.querySelector(
      ".Hw__product_description_image"
    );
    const additionalInformationImageElement = document.querySelector(
      ".Hw__additional_information_image"
    );
    // New: Get the main description image element
    const descriptionMainImage = document.querySelector(
      ".Hw__description_main img"
    );

    if (skuElement) skuElement.innerHTML = `SKU: ${sku}`;
    if (weightElement) weightElement.innerHTML = `${weight}`;
    if (dimElement) dimElement.innerHTML = `${dim}`;
    if (countryElement) countryElement.innerHTML = `${country}`;

    if (descriptionElement) {
      if (variantDescription.trim() !== "" && variantDescription !== "null") {
        descriptionElement.innerHTML = renderPortableText(variantDescription);
      } else {
        descriptionElement.innerHTML = defaultProductDescription;
      }
    }

    if (imageElement) {
      if (variantImageUrl && variantImageUrl !== "null") {
        imageElement.src = variantImageUrl;
      } else {
        imageElement.src = defaultProductImage;
      }
    }

    if (additionalInformationImageElement) {
      if (
        additionalInformationImageUrl &&
        additionalInformationImageUrl !== "null"
      ) {
        additionalInformationImageElement.src = additionalInformationImageUrl;
      } else {
        if (typeof defaultAdditionalInformationImage !== 'undefined') {
        additionalInformationImageElement.src =
          defaultAdditionalInformationImage;
        }
      }
    }

    // New: Logic for .Hw__description_main image
    if (descriptionMainImage) {
      const variantInputs = document.querySelectorAll(".Hw__product-input");
      let newImgUrl = defaultProductImage;
      if (variantInputs.length > 1) {
        // More than one variant: show variant description image
        if (variantImageUrl && variantImageUrl !== "null") {
          newImgUrl = variantImageUrl;
        }
      }
      // Set both src and data-src
      descriptionMainImage.src = newImgUrl;
      descriptionMainImage.setAttribute("data-src", newImgUrl);
      // If lazyload, force reload
      if (descriptionMainImage.classList.contains("lazyload")) {
        descriptionMainImage.classList.remove("lazyloaded");
        descriptionMainImage.classList.add("lazyload");
        // If lazysizes is present, trigger it
        if (window.lazySizes && window.lazySizes.loader) {
          window.lazySizes.loader.unveil(descriptionMainImage);
        }
      }
    }
  }

  // Get fallback/default description and image on page load
  const descriptionElement = document.querySelector(
    ".Hw__product_description_text"
  );
  const imageElement = document.querySelector(".Hw__product_description_image");
  const defaultProductDescription = descriptionElement
    ? descriptionElement.innerHTML
    : "";
  const defaultProductImage = imageElement ? imageElement.src : "";

  // Handle pre-selected variant on page load
  function checkDefaultChecked() {
    const defaultChecked = document.querySelector(".Hw__product-input:checked");
    if (defaultChecked) {
      updateProductInfo(defaultChecked);
    } else {
      if (descriptionElement)
        descriptionElement.innerHTML = defaultProductDescription;
      if (imageElement) imageElement.src = defaultProductImage;
    }
  }

  // Listen for variant changes
  document.body.addEventListener("change", function (event) {
    if (event.target.matches(".Hw__product-input")) {
      updateProductInfo(event.target);
    }
  });

  document.body.addEventListener("click", function (event) {
    const label = event.target.closest("label");
    if (
      label &&
      label.previousElementSibling &&
      label.previousElementSibling.matches(".Hw__product-input")
    ) {
      updateProductInfo(label.previousElementSibling);
    }
  });

  // --- PREVENT FLASH OF MAIN IMAGE: Set correct variant image immediately on load ---
  const variantInputs = document.querySelectorAll(".Hw__product-input");
  const checkedVariant = document.querySelector(".Hw__product-input:checked");
  const descriptionMainImage = document.querySelector(
    ".Hw__description_main img"
  );
  if (variantInputs.length > 1 && checkedVariant && descriptionMainImage) {
    const variantImageUrl = checkedVariant.getAttribute(
      "data-description-image"
    );
    if (variantImageUrl && variantImageUrl !== "null") {
      descriptionMainImage.src = variantImageUrl;
      descriptionMainImage.setAttribute("data-src", variantImageUrl);
      if (descriptionMainImage.classList.contains("lazyload")) {
        descriptionMainImage.classList.remove("lazyloaded");
        descriptionMainImage.classList.add("lazyload");
        if (window.lazySizes && window.lazySizes.loader) {
          window.lazySizes.loader.unveil(descriptionMainImage);
        }
      }
    }
  }

  checkDefaultChecked();
});

// *******************************************************

// document.addEventListener("DOMContentLoaded", function () {
//   function isMobileOrTablet() {
//     return window.innerWidth <= 1099; // Adjust breakpoint if needed
//   }

//   const items = document.querySelectorAll(".product_usp-item");

//   items.forEach((item) => {
//     const description = item.querySelector(".product_usp-item-description");

//     if (!description) return;

//     // Tooltip effect on hover for desktop
//     if (!isMobileOrTablet()) {
//       item.addEventListener("mouseenter", function () {
//         hideAllDescriptions();
//         showTooltip(description, item);
//       });

//       item.addEventListener("mouseleave", function () {
//         description.style.display = "none";
//       });
//     } else {
//       // Click functionality for mobile/tablet
//       item.addEventListener("click", function (event) {
//         event.stopPropagation(); // Prevents event bubbling
//         const isActive = description.style.display === "block";

//         hideAllDescriptions(); // Hide others before showing new one

//         if (!isActive) {
//           showTooltip(description, item);
//         }
//       });
//     }
//   });

//   // Hide tooltip when clicking outside
//   document.addEventListener("click", function () {
//     hideAllDescriptions();
//   });

//   function hideAllDescriptions() {
//     document.querySelectorAll(".product_usp-item-description").forEach((desc) => {
//       desc.style.display = "none";
//     });
//   }

//   function showTooltip(description, item) {
//     description.style.display = "block";
//     // description.style.position = "absolute";
//     // description.style.background = "#000";
//     // description.style.color = "#fff";
//     // description.style.padding = "8px 12px";
//     // description.style.borderRadius = "4px";
//     // description.style.boxShadow = "0px 2px 5px rgba(0, 0, 0, 0.2)";
//     // description.style.zIndex = "1000";
//     // description.style.maxWidth = "250px";

//     const rect = item.getBoundingClientRect();
//     // description.style.top = `${rect.top + window.scrollY - description.offsetHeight - 10}px`;
//     // description.style.left = `${rect.left + window.scrollX + rect.width / 2 - description.offsetWidth / 2}px`;
//   }
// });
// *******************************************************

document.addEventListener("DOMContentLoaded", function () {
  if (window.matchMedia("(max-width: 1100px)").matches) {
    const readMoreBtn = document.querySelector(
      ".Hw__ingredients_main .read-more-btn"
    );
    if (!readMoreBtn) return; // Exit if button is not found

    const hiddenItems = document.querySelectorAll(
      ".ingredient-item:nth-child(n+3)"
    );

    let isExpanded = false;

    readMoreBtn.addEventListener("click", function () {
      isExpanded = !isExpanded; // Toggle state

      hiddenItems.forEach((item) => {
        item.style.display = isExpanded ? "flex" : "none";
      });

      // Update button text and rotate icon
      readMoreBtn.innerHTML = isExpanded
        ? `Read Less 
          <svg class="chevron-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 15l6-6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>`
        : `Read More 
          <svg class="chevron-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>`;
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  // Only apply on mobile
  if (window.innerWidth <= 749) {
    const tabSections = document.querySelectorAll(".hw-product--tab");
    const tabContent = document.querySelector(".hw-product--singleTabContent");

    tabSections.forEach((section) => {
      // Create accordion headers dynamically using existing H4 titles inside each tab
      const titleElement = section.querySelector("h4");
      if (titleElement) {
        const header = document.createElement("div");
        header.className = "hw-accordion-header";
        header.textContent = titleElement.textContent;

        // Insert accordion header before the tab section
        tabContent.insertBefore(header, section);

        // Toggle accordion content on click
        header.addEventListener("click", function () {
          const isActive = section.classList.contains("active");

          // Close all tabs
          tabSections.forEach((tab) => tab.classList.remove("active"));
          document
            .querySelectorAll(".hw-accordion-header")
            .forEach((h) => h.classList.remove("active"));

          // Toggle current
          if (!isActive) {
            section.classList.add("active");
            header.classList.add("active");

            
            
              const headerTop = header.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                top: headerTop - 250,
                behavior: "smooth",
              });
            
          }
        });
      }
    });

    // Hide all tabs initially
    tabSections.forEach((tab) => tab.classList.remove("active"));
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if (window.matchMedia("(max-width: 1100px)").matches) {
    const descriptionContainer = document.querySelector(
      ".Hw__product_description_text"
    );
    const readMoreBtn = document.querySelector(".read-more-btn");

    if (!descriptionContainer || !readMoreBtn) return;

    const originalHTML = descriptionContainer.innerHTML; // Store full content
    const wordLimit = 50; // Limit words

    function truncateHTML(html, limit) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      let wordCount = 0;

      function processNode(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          const words = node.nodeValue.trim().split(/\s+/);
          if (wordCount + words.length > limit) {
            node.nodeValue =
              words.slice(0, limit - wordCount).join(" ") + "...";
            return true;
          }
          wordCount += words.length;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          for (let i = 0; i < node.childNodes.length; i++) {
            if (processNode(node.childNodes[i])) {
              while (node.childNodes.length > i + 1) {
                node.removeChild(node.lastChild);
              }
              return true;
            }
          }
        }
        return false;
      }

      processNode(tempDiv);
      return tempDiv.innerHTML;
    }

    // Apply truncation initially
    descriptionContainer.innerHTML = truncateHTML(originalHTML, wordLimit);

    let isExpanded = false;

    readMoreBtn.addEventListener("click", function () {
      isExpanded = !isExpanded;
      descriptionContainer.innerHTML = isExpanded
        ? originalHTML
        : truncateHTML(originalHTML, wordLimit);

      readMoreBtn.innerHTML = isExpanded
        ? `Read Less <svg class="chevron-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 15l6-6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>`
        : `Read More <svg class="chevron-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>`;

      
      if (!isExpanded && window.innerWidth <= 749) {
        const activeTab = readMoreBtn.closest(".hw-product--tab");
        if (activeTab) {
          const header = activeTab.previousElementSibling;
          if (header && header.classList.contains("hw-accordion-header")) {
            
              const headerTop = header.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                top: headerTop - 250,
                behavior: "smooth",
              });
            
          }
        }
      }
    });
  }
});


// *******************************************************

document.addEventListener("DOMContentLoaded", function () {
  function updateSaleBadge(productCard) {
    const selectedOption = productCard.querySelector(
      ".variant-custom-option.selected"
    );
    const badge = productCard.querySelector(".hw--badge-sale");

    if (selectedOption && badge) {
      const percentage = selectedOption.getAttribute("data-percentage").trim();
      if (percentage) {
        badge.textContent = percentage;
        badge.style.display = "flex";
      } else {
        badge.textContent = "";
        badge.style.display = "none";
      }
    }
  }

  document
    .querySelectorAll(".custom-collection.product-card")
    .forEach(function (productCard) {
      updateSaleBadge(productCard);

      productCard
        .querySelectorAll(".variant-custom-option")
        .forEach(function (option) {
          option.addEventListener("click", function () {
            option
              .closest(".variant-options")
              .querySelectorAll(".variant-custom-option")
              .forEach(function (el) {
                el.classList.remove("selected");
              });

            option.classList.add("selected");

            updateSaleBadge(productCard);
          });
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
  function updateSaleBadgeForListView(productCard) {
    const selectedOption = productCard.querySelector(
      ".variant-custom-option.selected"
    );

    const badge_two = productCard.querySelector(".hw--badge-sale-pp");

    if (selectedOption && badge_two) {
      const percentage = selectedOption.getAttribute("data-percentage").trim();
      if (percentage) {
        badge_two.textContent = percentage;
        badge_two.style.display = "flex";
      } else {
        badge_two.textContent = "";
        badge_two.style.display = "none";
      }
    }
  }

  document
    .querySelectorAll(".hw--custom-product-variant-listview")
    .forEach(function (productCard) {
      updateSaleBadgeForListView(productCard);

      productCard
        .querySelectorAll(".variant-custom-option")
        .forEach(function (option) {
          option.addEventListener("click", function () {
            option
              .closest(".variant-options")
              .querySelectorAll(".variant-custom-option")
              .forEach(function (el) {
                el.classList.remove("selected");
              });

            option.classList.add("selected");

            updateSaleBadgeForListView(productCard);
          });
        });
    });
});
document.addEventListener('DOMContentLoaded', function () {
    const searchInputs = document.querySelectorAll('input[type="search"]');

    searchInputs.forEach((searchInput) => {
      let timer;

      function triggerWithDelay() {
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (typeof window.hwCurrencyConverterLoad === 'function') {
            window.hwCurrencyConverterLoad();
          }
        }, 1000); // 1 second delay
      }

      searchInput.addEventListener('click', triggerWithDelay);
      searchInput.addEventListener('copy', triggerWithDelay);
      searchInput.addEventListener('input', triggerWithDelay);
      searchInput.addEventListener('paste', triggerWithDelay);
    });
  });

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.href.includes('type=article')) {
    document.querySelectorAll('input[type="search"]').forEach(function(input) {
      input.classList.add('gf-ignore');
    });
  }
  // Check if Shopify object exists and locale is Arabic
  if (typeof Shopify !== 'undefined' && Shopify.locale === 'ar') {
    const searchInputs = document.querySelectorAll('input[type="search"][name="q"].gf-ignore');
    
    if (!searchInputs.length) return;
    
    const doneTypingInterval = 1000; // 1 second delay
    
    function getSearchUrl(query) {
      // Handle different Shopify URL structures
      const basePath = window.location.pathname.startsWith('/ar/') ? 
        '/ar' : 
        `/${Shopify.locale.toLowerCase()}`;
      
      return `${basePath}/search?q=${encodeURIComponent(query)}&type=article&options[prefix]=last`;
    }
    
    function handleSearchRedirect(input) {
      return function() {
        const query = input.value.trim();
        
        // Only redirect if at least 2 characters
        if (query.length > 1) {
          const searchUrl = getSearchUrl(query);
          
          // Only redirect if we're not already on a search results page
          // or if the search query is different from the current one
          const currentUrl = window.location.href;
          const isAlreadyOnSearchPage = currentUrl.includes('/search?q=');
          const currentQuery = isAlreadyOnSearchPage ? 
            new URLSearchParams(window.location.search).get('q') || '' : '';
          
          if (!isAlreadyOnSearchPage || query !== currentQuery) {
            window.location.href = searchUrl;
          }
        }
      };
    }
    
    // Process each search input individually
    searchInputs.forEach(function(searchInput) {
      let typingTimer;
      
      const redirectHandler = handleSearchRedirect(searchInput);
      
      // Debug logging to see what's happening
      
      
      // Main input event
      searchInput.addEventListener('input', function(e) {
        
        clearTimeout(typingTimer);
        typingTimer = setTimeout(redirectHandler, doneTypingInterval);
      });
      
      // Paste event
      searchInput.addEventListener('paste', function(e) {
        
        clearTimeout(typingTimer);
        // Short delay to allow paste to complete
        setTimeout(function() {
          typingTimer = setTimeout(redirectHandler, doneTypingInterval);
        }, 100);
      });
      
      // Keydown for Enter key
      searchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          
          clearTimeout(typingTimer);
          redirectHandler();
        }
      });
      
      // Blur event (when user clicks away)
      searchInput.addEventListener('blur', function() {
        
        clearTimeout(typingTimer);
        const query = searchInput.value.trim();
        if (query.length > 1) {
          redirectHandler();
        }
      });
      
      // Change event for autofill
      searchInput.addEventListener('change', function() {
        
        clearTimeout(typingTimer);
        typingTimer = setTimeout(redirectHandler, doneTypingInterval);
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 1024) return;
  const body = document.body;
  let activeInput = null;

  function lockBody() {
    body.classList.add('overflow-hidden');
  }

  function unlockBody() {
    body.classList.remove('overflow-hidden');
  }

  // Lock when search input is focused
  document.addEventListener('focusin', function(e) {
    if (e.target.matches('input[type="search"]')) {
      activeInput = e.target;
      lockBody();
    }
  });

  // Unlock when input becomes empty
  document.addEventListener('input', function(e) {
    if (e.target.matches('input[type="search"]')) {
      activeInput = e.target;
      const val = e.target.value.trim();
      if (val === '') {
        unlockBody();
      } else {
        lockBody();
      }
    }
  });

  // Unlock on reset button click
  document.addEventListener('click', function(e) {
    const resetBtn = e.target.closest('.reset__button, [type="reset"]');
    if (resetBtn) {
      unlockBody();
      if (activeInput) setTimeout(() => activeInput.blur(), 50);
      return; // stop further logic for reset click
    }

    // ✅ Remove overflow-hidden if clicked outside the search input
    const isInsideSearch = e.target.closest('input[type="search"]');
    if (!isInsideSearch) {
      unlockBody();
      if (activeInput) activeInput.blur();
      activeInput = null;
    }
  });

  // ✅ Unlock on scroll only if input is empty
  ['scroll', 'wheel', 'touchmove'].forEach(evt => {
    document.addEventListener(evt, function() {
      if (!activeInput) return;
      if (activeInput.value.trim() === '') {
        unlockBody();
        setTimeout(() => activeInput.blur(), 50);
        activeInput = null;
      }
    }, { passive: true });
  });
});

// *******************************************************
document.addEventListener('DOMContentLoaded', function() {
  const searchIcon = document.querySelector('.header__icon--search');
  const searchInput = document.getElementById('Search-In-Modal');
  
  if (searchIcon && searchInput) {
    searchIcon.addEventListener('click', function() {
      searchInput.value = '';
    });
  }
});

document.addEventListener("click", function (e) {
    const wrappers = document.querySelectorAll(".variant-custom-wrapper");
    const clickedWrapper = e.target.closest(".variant-custom-wrapper");

    wrappers.forEach(wrapper => {
        const isActive = wrapper.classList.contains("active");

        // Case 1: Clicked outside any wrapper
        if (!clickedWrapper && isActive) {
            wrapper.classList.remove("active");
        }

        // Case 2: Clicked on a wrapper that is NOT the currently active one
        if (clickedWrapper && clickedWrapper !== wrapper && isActive) {
            wrapper.classList.remove("active");
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
  initFeaturedCollectionSliders();
  initMobileImageSliders();
  initProductCards();
  bindViewCartButtons();
});

document.addEventListener('shopify:section:load', () => {
  initFeaturedCollectionSliders();
  initMobileImageSliders();
  initProductCards();
  bindViewCartButtons();
});

/* -------------------------------------------------
   FEATURED COLLECTION SLIDER
-------------------------------------------------- */
function initFeaturedCollectionSliders() {
  document.querySelectorAll('.hw-featured-collection--slider').forEach((slider) => {
    if (slider.classList.contains('swiper-initialized')) return;

    const section = slider.closest('[data-selector]') || slider.closest('section');

    new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      loop: false,
      watchOverflow: true,
      pagination: {
        el: section?.querySelector('.pagination-slider-buttons .swiper-pagination'),
        clickable: true,
        type: 'bullets',
        renderBullet(index, className) {
          return index < 4 ? `<span class="${className}"></span>` : '';
        },
      },
      navigation: {
        nextEl: section?.querySelector('.slider-collection-buttons .swiper-button-next'),
        prevEl: section?.querySelector('.slider-collection-buttons .swiper-button-prev'),
      },
      observer: true,
      observeParents: true,
      breakpoints: {
        320: { spaceBetween: 8 },
        768: { slidesPerView: 2, spaceBetween: 10 },
        1440: { spaceBetween: 20 },
      },
    });

    slider.classList.add('swiper-initialized');
  });
}

/* -------------------------------------------------
   MOBILE IMAGE SWIPER (PRODUCT CARD)
-------------------------------------------------- */
function initMobileImageSliders() {
  const sliders = document.querySelectorAll('.swiper-mobile--swappable');

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const slider = entry.target;
        if (slider.classList.contains('swiper-initialized')) return;

        let visibleDots = 5;
        let currentStart = 0;

        const swiper = new Swiper(slider, {
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: slider.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
          },
          observer: true,
          observeParents: true,
          on: {
            init() {
              updatePagination(this);
            },
            slideChange() {
              updatePagination(this);
            },
          },
        });

        slider.classList.add('swiper-initialized');
        obs.unobserve(slider);

        function updatePagination(swiperInstance) {
          const bullets = slider.querySelectorAll('.swiper-pagination-bullet');
          const activeIndex = swiperInstance.activeIndex;
          const total = bullets.length;

          if (!total) return;

          if (activeIndex >= currentStart + visibleDots) {
            currentStart = activeIndex - visibleDots + 1;
          } else if (activeIndex < currentStart) {
            currentStart = activeIndex;
          }

          bullets.forEach((b, i) => {
            b.style.display =
              i >= currentStart && i < currentStart + visibleDots
                ? 'inline-block'
                : 'none';
            b.classList.toggle('swiper-pagination-bullet-active', i === activeIndex);
          });
        }
      });
    },
    { rootMargin: '200px', threshold: 0.1 }
  );

  sliders.forEach((slider) => observer.observe(slider));
}

function bindViewCartButtons() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  document.querySelectorAll('.al_view_cart').forEach((btn) => {
    if (btn.dataset.viewCartBound === 'true') return;

    btn.dataset.viewCartBound = 'true';

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      cartDrawer.classList.add('active');
    });
  });
}




/* -------------------------------------------------
   PRODUCT CARD (VARIANTS + IMAGE + BADGE + CART)
-------------------------------------------------- */
function initProductCards() {
  document.querySelectorAll('.product-card').forEach((productCard) => {
    const jsonEl = productCard.querySelector('.product-variants-json');
    if (!jsonEl) return;

    const variants = JSON.parse(jsonEl.textContent);
    const addToCartButtons = productCard.querySelectorAll('.add-to-cart');

    let selectedOptions = Array.from(
      productCard.querySelectorAll('.variant-custom-wrapper')
    ).map((w) => w.querySelector('.variant-selected')?.innerText.trim());

    const findVariant = () =>
      variants.find((v) =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );

    const updateVariantInfo = (variant) => {
      if (!variant) return;

      addToCartButtons.forEach((btn) => {
        btn.disabled = !variant.available;
        btn.dataset.variantId = variant.id;
      });
    };

    const updateSliderToVariant = (option) => {
      const swiperWrapper = productCard.querySelector('.swiper-wrapper');
      if (!swiperWrapper) return;

      const altText = option.dataset.var_alt_txt;
      if (!altText) return;

      const images = swiperWrapper.querySelectorAll('img');
      const matchedImage = Array.from(images).find(
        (img) => img.getAttribute('alt') === altText
      );

      if (!matchedImage) return;

      const index = Array.from(images).indexOf(matchedImage);
      const swiper = swiperWrapper.closest('.swiper-container')?.swiper;

      if (swiper && index !== -1) swiper.slideTo(index, 0);
    };

    const updatePercentage = (option) => {
      const badge =
        productCard.querySelector('.hw--badge-sale') ||
        productCard.querySelector('.hw--badge-sale-pp');

      if (!badge) return;

      const percentage = option.dataset.percentage?.trim();

      if (percentage) {
        badge.textContent = percentage;
        badge.style.display = 'flex';
      } else {
        // IMPORTANT: clear incorrect auto-calculated values
        badge.textContent = '';
        badge.style.display = 'none';
      }
    };

    // VARIANT DROPDOWN OPEN / CLOSE (MISSING PART)
    productCard.querySelectorAll('.variant-custom-wrapper').forEach((wrapper) => {
      const selected = wrapper.querySelector('.variant-selected');

      wrapper.addEventListener('click', function () {
        this.classList.toggle('active');
      });

      wrapper.querySelectorAll('.variant-custom-option').forEach((option) => {
        option.addEventListener('click', function (event) {
          event.stopPropagation(); // CRITICAL — prevents instant close

          selected.innerText = this.innerText;
          wrapper.dataset.selected = this.dataset.value;

          wrapper.classList.remove('active');
        });
      });
    });


    productCard.querySelectorAll('.variant-custom-option').forEach((option) => {
      option.addEventListener('click', () => {
        const idx = Number(option.dataset.optionIndex);
        selectedOptions[idx] = option.dataset.optionValue;

        const wrapper = option.closest('.variant-custom-wrapper');
        wrapper.querySelector('.variant-selected').innerText =
          option.dataset.optionValue;

        wrapper
          .querySelectorAll('.variant-custom-option')
          .forEach((o) => o.classList.remove('selected'));

        option.classList.add('selected');
         const updatePrice = (variant) => {
          if (!variant) return;

          const priceEls = productCard.querySelectorAll('.variant-price');
          if (!priceEls.length) return;

          const formatMoney = (cents) => (cents / 100).toFixed(2);

          const price = formatMoney(variant.price);
          const compareAt =
            variant.compare_at_price && variant.compare_at_price > variant.price
              ? formatMoney(variant.compare_at_price)
              : null;

          const moneyFormat = window.Shopify?.money_format || "{{amount}} AED";
          const formattedPrice = window.Shopify?.formatMoney
            ? window.Shopify.formatMoney(variant.price, moneyFormat)
            : `${price} AED`;

          const formattedCompare = compareAt && window.Shopify?.formatMoney
            ? window.Shopify.formatMoney(variant.compare_at_price, moneyFormat)
            : compareAt ? `${compareAt} AED` : null;

          priceEls.forEach((priceEl) => {
            priceEl.innerHTML = compareAt
              ? `<div class="price__sale">
                  <span class="price-item price-item--regular money hw-currency"
                        doubly-currency="AED" doubly-currency-aed="${compareAt}"
                        data-currency="AED" data-store-currency="AED ${compareAt}">${formattedCompare}</span>
                  <span class="price-item price-item--sale money hw-currency"
                        doubly-currency="AED" doubly-currency-aed="${price}"
                        data-currency="AED" data-store-currency="AED ${price}">${formattedPrice}</span>
                </div>`
              : `<div class="price__regular">
                  <span class="price-item price-item--regular money hw-currency"
                        doubly-currency="AED" doubly-currency-aed="${price}"
                        data-currency="AED" data-store-currency="AED ${price}">${formattedPrice}</span>
                </div>`;
          });

          setTimeout(() => {
            window.hwCurrencyConverterLoad?.();
          }, 50);
        };

        const variant = findVariant();
        if (variant) {
          updateVariantInfo(variant);
          updatePrice(variant);
         
        }
       


        updateSliderToVariant(option);
        updatePercentage(option);
      });
    });

    const initialVariant = findVariant();
    if (initialVariant) {
      updateVariantInfo(initialVariant);

      const initialSelectedOption =
        productCard.querySelector('.variant-custom-option.selected') ||
        productCard.querySelector('.variant-custom-option[data-selected="true"]');

      if (initialSelectedOption) {
        updatePercentage(initialSelectedOption);
      }

      productCard.dispatchEvent(
        new CustomEvent('variant:change', {
          bubbles: true,
          detail: { variant: initialVariant }
        })
      );
    }

    // 🔒 PREVENT DUPLICATE BINDING
    addToCartButtons.forEach((addToCartButton) => {
  if (!addToCartButton) return;

  // 🔒 Prevent duplicate binding PER BUTTON
  if (addToCartButton.dataset.cartBound === 'true') return;
  addToCartButton.dataset.cartBound = 'true';

  // Remove old handler if exists
  if (addToCartButton._cartHandler) {
    addToCartButton.removeEventListener('click', addToCartButton._cartHandler);
  }

  addToCartButton._cartHandler = function () {
    const id = addToCartButton.dataset.variantId;
    if (!id || addToCartButton.classList.contains('loading')) return;

    addToCartButton.classList.add('loading');
    addToCartButton.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: 1 }),
    })
      .then(() => fetch('/cart.js'))
      .then((r) => r.json())
      .then((cart) => {
        // Show "View cart" temporarily
        const viewCartWrapper =
          addToCartButton.closest('.al_add_to_cart_view_cart') ||
          addToCartButton.closest('.HW__variant');

        if (viewCartWrapper) {
          viewCartWrapper.classList.add('active');
          clearTimeout(viewCartWrapper._hideTimer);
          viewCartWrapper._hideTimer = setTimeout(() => {
            viewCartWrapper.classList.remove('active');
          }, 4000);
        }

        // Update cart count
        document.querySelectorAll('.cart-count-bubble').forEach((el) => {
          el.style.display = 'flex';
          el.textContent = cart.item_count;
        });

        // Refresh cart drawer
        fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`)
          .then((res) => res.text())
          .then((html) => {
            const cartDrawer = document.querySelector('cart-drawer');
            if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const sectionHtml = doc.querySelector('#CartDrawer')?.outerHTML;

            if (!sectionHtml) return;

            cartDrawer.renderContents({
              id: 'cart-drawer',
              sections: { 'cart-drawer': sectionHtml },
            });
            
            cartDrawer.classList.remove('is-empty');
            window?.bindUpsellAddToCartButtons?.();
            bindViewCartButtons(); // rebind after drawer refresh
            timer = setTimeout(() => {
              if (typeof window.hwCurrencyConverterLoad === 'function') {
                window.hwCurrencyConverterLoad();
              }
            }, 1000); 
          });
      })
      .catch((err) => console.error('Add to cart error:', err))
      .finally(() => {
        addToCartButton.classList.remove('loading');
        addToCartButton.disabled = false;
      });
  };

  addToCartButton.addEventListener('click', addToCartButton._cartHandler);
});


  });
}


document.addEventListener("DOMContentLoaded", function () {
  const selectors = [
    ".popup-trigger img",
    ".hw-exihibition--slider .swiper-popup-vip_visitors .swiper-slide img"
  ];

  const images = document.querySelectorAll(selectors.join(","));

  images.forEach(function(img) {
    img.addEventListener("contextmenu", function(e) {
      e.preventDefault();
      return false;
    });
  });
});
